import { Injectable } from "@angular/core";

import { DffSimpelDialog } from "@dffedb/ui";

import { LoginHjaelpRepository } from "./login-hjaelp.repository";

@Injectable({ providedIn: "root" })
export class LoginHjaelpService {
    constructor(
        private readonly dialog: DffSimpelDialog,
        private readonly repository: LoginHjaelpRepository
    ) {}

    public async visLoginHjaelpDialog(): Promise<void> {
        const indstillinger = await this.repository.hentIndstillinger().toPromise();
        await this.dialog.openOk(indstillinger.overskrift, indstillinger.indhold, { maxWidth: 400 });
    }

    public async visLoginHjaelpServiceProDialog(): Promise<void> {
        const indstillinger = await this.repository.hentIndstillinger().toPromise();
        const hjaelpeTekst = {
            overskrift: "Glemt din kode?",
            indhold: "Hvis du har glemt dit password, kan administrationen hos din tilknyttede forsyning hjælpe med at lave et nyt."
        };

        if (indstillinger && (indstillinger.serviceproOverskrift || indstillinger.serviceproOverskrift.trim() !== "")) {
            hjaelpeTekst.overskrift = indstillinger.serviceproOverskrift;
        }
        if (indstillinger && (indstillinger.serviceproIndhold || indstillinger.serviceproIndhold.trim() !== "")) {
            hjaelpeTekst.indhold = indstillinger.serviceproIndhold;
        }

        await this.dialog.openOk(hjaelpeTekst.overskrift, hjaelpeTekst.indhold, { maxWidth: 400 });
    }
}
